import type { PercentCrop } from 'react-image-crop';

export const findAspectRatioFromPercentCrop = (percentCrop: Omit<PercentCrop, 'unit'>, width: number, height: number) => {
  const { width: cropWidthPercent, height: cropHeightPercent } = percentCrop;
  const croppedHeight = height * (cropHeightPercent / 100);
  const croppedWidth = width * (cropWidthPercent / 100);
  const aspectRatio = croppedWidth / croppedHeight;
  return aspectRatio;
};
